import { createFetcher } from '@udemy/graphql';
export const fetcher = createFetcher({
  getUrl() {
    return '/api/2024-01/graphql/';
  }
});
//# sourceMappingURL=fetcher.js.map